/**
 * Copyright (c) 2025-2026 Four Hour Window LLC
 * All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */


import React, { useState } from 'react';

import { API_BASE_URL } from '../../utils/apiBaseUrl.ts';
function ForgotPassword({ onBackToLogin }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [emailSent, sentEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');
    sentEmailSent(true);
    try {
      const response = await fetch(`${API_BASE_URL}/.netlify/functions/request-password-reset`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to send reset email');
      }

      setMessage('Password reset email sent! Check your inbox.');
      setEmail(''); // Clear the form
    } catch (error) {
      console.error("Error:", error);
      setError(error.message || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="forgot-pass">
      <div className="panel">
         {!emailSent && (
                <h2 className="text-2xl font-bold text-center mb-6 text-gray-800">Forgot Password?</h2>
         )}
        {message && (
          <div className="mb-4 p-4 bg-green-100 text-green-700 rounded">
            {message}
          </div>
        )}
        
        {error && (
          <div className="mb-4 p-4 bg-red-100 text-red-700 rounded">
            {error}
          </div>
        )}
        {!emailSent && (
            <form onSubmit={handleSubmit}>
            <label htmlFor="forgot-password">Email:</label>
            <input
                id="forgot-password"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
            />
            <button type="submit" className="btn" disabled={loading}>
                {loading ? 'Sending...' : 'Reset Password'}
            </button>
            </form>
        )}
      </div>
      <button className="btn btn--small" onClick={onBackToLogin} disabled={loading}>
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 512 404.43">
            <path fill="white" fillRule="nonzero" d="m68.69 184.48 443.31.55v34.98l-438.96-.54 173.67 159.15-23.6 25.79L0 199.94 218.6.02l23.6 25.79z"/>
          </svg>
        </span>
        Back to Login
      </button>
    </div>
  );
}

export default ForgotPassword;